export default __webpack_public_path__ + "static/media/2096-01.31374c51.jpg";